import type { LinkProps } from "@/types";

/**
 * Link Component
 * Handles internal and external links with proper attributes
 */
export const Link = ({
  href,
  children,
  external = false,
  className = '',
  target,
}: LinkProps) => {
  // Base link classes
  const baseClasses = 'text-primary hover:text-primary/80 transition-colors duration-200';

  // External link attributes
  const externalProps = external || target === '_blank'
    ? {
        target: target || '_blank',
        rel: 'noopener noreferrer',
      }
    : {};

  return (
    <a href={href} className={`${baseClasses} ${className}`} {...externalProps}>
      {children}
    </a>
  );
};

export default Link;
